import { Controller, FieldValues, useFormState } from 'react-hook-form';
import { Input } from '@heroui/react';
import { FormInputProps } from './types';

const FormInput = <TFieldValues extends FieldValues = FieldValues>({
  name,
  control,
  label,
  placeholder,
  isRequired = false,
  isDisabled = false,
  description,
  className,
  type = 'text',
  showErrorOnTouched = true,
  ...rest
}: FormInputProps<TFieldValues>) => {
  const { touchedFields, errors, isSubmitted } = useFormState({ control });
  const fieldError = errors[name]?.message as string | undefined;
  const isTouched = touchedFields[name];
  const showError = showErrorOnTouched ? (isTouched || isSubmitted) && !!fieldError : !!fieldError;

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Input
          {...field}
          {...rest}
          type={type}
          label={label}
          placeholder={placeholder}
          isRequired={isRequired}
          isDisabled={isDisabled}
          description={description}
          className={className}
          isInvalid={showError}
          errorMessage={showError ? fieldError : undefined}
        />
      )}
    />
  );
};

FormInput.displayName = 'FormInput';

export default FormInput;
